export class Observer {
  constructor(method) {
    this.method = method;
    this.id = Date.now();
  }
}